module.exports = __webpack_public_path__ + "img/no_image_placeholder.eb7fbe77.png";